<template>
  <div>
    <v-container class="pa-6 form-container mt-16" max-width="500px">
      <h1 class="text-h4 font-weight-bold mb-6 text-center">Create Your Account</h1>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
            v-model="form.fullName"
            label="Full Name"
            class="white-background"
            :rules="[rules.required]"
            outlined
            dense
            required
        />

        <v-text-field
            v-model="form.email"
            label="Email"
            type="email"
            class="white-background"
            :rules="[rules.required, rules.email]"
            outlined
            filled
            dense
            required
        />

        <v-text-field
            v-model="form.password"
            label="Password"
            class="white-background"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :rules="[rules.required, rules.min(6)]"
            @click:append="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            outlined
            dense
            required
        />

        <v-text-field
            v-model="form.confirmPassword"
            label="Confirm Password"
            class="white-background"
            :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :rules="[rules.required, passwordMatch]"
            @click:append="showConfirmPassword = !showConfirmPassword"
            :type="showConfirmPassword ? 'text' : 'password'"
            outlined
            dense
            required
        />

        <v-checkbox
            v-model="form.acceptTerms"
            :rules="[rules.acceptTerms]"
            color="black"
            label="I accept the Terms and Conditions"
            required
            class="mt-4"
        />

        <v-btn
            color="primary"
            class="mt-6"
            large
            block
            @click="submit"
        >
          Register
        </v-btn>
      </v-form>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "RegisterPage",
  data() {
    return {
      valid: false,
      showPassword: false,
      showConfirmPassword: false,
      form: {
        fullName: "",
        email: "",
        password: "",
        confirmPassword: "",
        acceptTerms: false,
      },
      rules: {
        required: (v) => !!v || "This field is required",
        email: (v) =>
            /.+@.+\..+/.test(v) || "Please enter a valid email address",
        min: (length) => (v) =>
            (v && v.length >= length) || `Minimum ${length} characters`,
        acceptTerms: (v) => v || "You must accept the terms and conditions",
      },
    };
  },
  methods: {
    passwordMatch(value) {
      return value === this.form.password || "Passwords must match";
    },
    submit() {
      if (this.$refs.form.validate()) {
        alert("Registration successful!");
      }
    },
  },
};
</script>

<style scoped>
.form-container {
  background: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: none;
  border: none;
  padding: 40px;
  width: 100%;
  max-width: 500px;
  color: #222;
}

h1 {
  font-family: 'Montserrat', sans-serif;
  color: #fff; /* white text to pop against bg */
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}

.white-background >>> .v-input__control > .v-input__slot {
  background-color: white !important;
  border-radius: 12px;
}
</style>